import { render, staticRenderFns } from "./CreateAudience.vue?vue&type=template&id=d5cec1d4&scoped=true&"
import script from "./CreateAudience.vue?vue&type=script&lang=js&"
export * from "./CreateAudience.vue?vue&type=script&lang=js&"
import style0 from "./CreateAudience.vue?vue&type=style&index=0&id=d5cec1d4&lang=scss&scoped=true&"
import style1 from "./CreateAudience.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cec1d4",
  null
  
)

export default component.exports